
// Value returned is how far in from the left side the grid begins.
function findGridLeftPosition() {
    var grid = $( ".check-me" );
    var offset = grid.offset();
    console.log('ok');
    console.log( "left: " + offset.left + ", top: " + offset.top );
    return offset.left;
}
function goToByScroll(id){
      // Remove "link" from the ID
      id = id.replace("link", "");
      // Scroll
      $('html,body').animate({
        scrollTop: $("#"+id).offset().top},
        'slow');
  }


$(document).ready(function(){


    $(window).on("load", function (e) {

    //      var pos = findGridLeftPosition();
    // var newPos = pos-105;
    // // If the new position is below 0. Set it to zero. We do not want our logo
    // // to go too far to the left.
    // if(newPos<20) {
    //   newPos=20;
    // }
    // console.log('placing it at :'+newPos);
    // $('.aside').css('left',newPos);

    });



});
window.onresize = function(event) {
    // var pos = findGridLeftPosition();
    // var newPos = pos-105;
    // // If the new position is below 0. Set it to zero. We do not want our logo
    // // to go too far to the left.
    // if(newPos<20) {
    //   newPos=20;
    // }
    // console.log('placing it at :'+newPos);
    // $('.aside').css('left',newPos);
};
